module.exports = __webpack_public_path__ + "static/media/sfx_animal_monkey_02.e64bcaad.mp3";